import { ResponsiveProps } from '..';
import { useCallback, useEffect, useRef, useState } from 'react';
import { CaseOption } from '../../ParallelCase';
import classNames from 'classnames';
import ModalComponent from 'v3/common/components/ModalComponent';

const mobMaxCases = 2;

const Mobile = (props: ResponsiveProps) => {
  const {
    isShowAddCaseHoverMessage,
    cases,
    renderHoverMessage,
    isMaximumCasesExceeded,
    activeCaseIndex,
    onChangeActiveCaseIndex,
    onAddCase,
    onCloneCase,
    handleDeleteCase,
    children,
  } = props;

  const [openCaseIndex, setOpenCaseIndex] = useState<number | null>(null);
  const isAddIconRender = cases.length >= mobMaxCases;
  const lastItemRef = useRef<HTMLDivElement>(null);

  const onHandleBtnAction = (type: 'delete' | 'duplicate', idx: number) => {
    setOpenCaseIndex(null); // close modal
    if (type === 'delete') handleDeleteCase(idx);
    else onCloneCase(idx);
  };

  const renderCaseIndex = useCallback(
    (_: CaseOption, idx: number) => {
      const isActive = idx === activeCaseIndex;
      const labelClassName = classNames('nav-item', { active: isActive });

      return (
        <div key={idx} className="nav-item-wrap">
          <div
            ref={idx === cases.length - 1 ? lastItemRef : null}
            className={labelClassName}
            onClick={() => onChangeActiveCaseIndex(idx)}
          >
            <span className="nav-link">Case {idx + 1}</span>
            <i
              className="fa-solid fa-caret-down"
              onClick={(e) => {
                e.stopPropagation();
                setOpenCaseIndex(idx);
              }}
            ></i>
          </div>
        </div>
      );
    },
    [activeCaseIndex, onChangeActiveCaseIndex]
  );

  const renderAddCaseButton = (
    <button
      className="btn add-cases-btn btn-primary d-flex align-items-center"
      type="button"
      disabled={isMaximumCasesExceeded}
      onClick={onAddCase}
    >
      <i className="material-icons-outlined">add</i>
      {!isAddIconRender && <span className="ml-1">Add Case</span>}
    </button>
  );

  useEffect(() => {
    if (lastItemRef.current&&cases.length>1) {
      lastItemRef.current.scrollIntoView({
        behavior: 'smooth',
        inline: 'end',
        block: 'nearest',
      });
    }
  }, [cases.length]);

  return (
    <div className="add-case-mob">
      <div className="nav nav-tabs">
        <div className="d-flex nav-items-wrap case-index__container">{cases.map(renderCaseIndex)}</div>
        {isShowAddCaseHoverMessage ? renderHoverMessage : renderAddCaseButton}
      </div>
      {openCaseIndex !== null && (
        <ModalComponent
          onClose={() => setOpenCaseIndex(null)}
          title={`Case ${openCaseIndex !== null ? openCaseIndex + 1 : ''} `}
        >
          <div className="case-action-modal">
            <button
              className="btn btn-primary duplicate-btn"
              onClick={() => onHandleBtnAction('duplicate', openCaseIndex)}
            >
              <i className="fa-regular fa-copy"></i>
              <span>Duplicate</span>
            </button>
            {cases.length > 1 && (
              <button
                className="btn btn-danger delete-btn"
                onClick={() => onHandleBtnAction('delete', openCaseIndex)}
              >
                <i className="fa-regular fa-trash-can" aria-hidden="true"></i>
                <span>Delete</span>
              </button>
            )}
          </div>
        </ModalComponent>
      )}
      <div>{children}</div>
    </div>
  );
};

export default Mobile;
